import {ChangeDetectionStrategy, Component, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ProgressSpinner} from 'primeng/progressspinner';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'homey-resubscribe-redirect-page',
  standalone: true,
  imports: [ProgressSpinner, RouterLink],
  templateUrl: './resubscribe-redirect-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResubscribeRedirectPageComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);
  private readonly messageService = inject(MessageService);

  protected readonly error = signal<string | null>(null);

  async ngOnInit(): Promise<void> {
    const id = this.route.snapshot.queryParamMap.get('id');
    if (!id) {
      this.error.set('Invalid link. Please check your email or SMS for the correct link.');
      return;
    }

    try {
      const response = await firstValueFrom(
        this.http.get<{ url: string }>(`${environment.apiUrl}/api/public/payment/resubscribe`, {params: {id}})
      );
      window.location.href = response.url;
    } catch (e) {
      if (e instanceof HttpErrorResponse && e.status === 409) {
        this.messageService.add({
          severity: 'info',
          summary: 'Already subscribed',
          detail: 'You already have an active subscription.',
        });
        await this.router.navigate(['/']);
      } else {
        this.error.set('Something went wrong. Please try again or contact support.');
      }
    }
  }
}
